import styled from 'styled-components';
import EachAnswer from './EachAnswer';

const AnswerTitle = styled.h2`
  margin-top: 10%;
  font-size: 15px;
  color: #000;
  width: 90vw;
`;

/**
 * This component includes all the answers with their coressponding details for
 * wrong or correct asnwers
 *
 * @param {string} answerTitle Can be Wrong Answers or Correct Answers
 * @param {object} answersMaterials All correct or wrong answers details and images
 */

const Answers = ({
  answerTitle,
  answersMaterials
}) => (
  (answersMaterials.roundMaterials.length > 0) && (
    <>
      <AnswerTitle>
        {answerTitle}
      </AnswerTitle>
      {
        answersMaterials.roundMaterials.map((mat) => (
          <EachAnswer
            mat_image={mat.mat_image}
            disposal_header={mat.disposal_header}
            mat_nm={mat.mat_nm}
            disposal_body={mat.disposal_body}
            mat_id_value={mat.mat_id}
            answerTitle={answerTitle}
          />
        ))
      }
    </>
  )
);

export default Answers;
